import React, { Children } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { arrayOf, shape } from "prop-types";
import { selectors as environmentSelectors } from "reducers/environment";

import { selectors as i18nSelectors } from "reducers/i18n";

import I18n from "pages/_components/I18n";

export const FooterDesktop = (props) => {
    const { moreOptions, messages, currentStepRequest } = props;
    const isOnboardingInReview = currentStepRequest?.value?.onboarding?.status === "IN_REVIEW";

    if (!messages || isOnboardingInReview) {
        return null;
    }

    return (
        <footer className="app-default-footer">
            <ul className="legal-nav list-inline list-footer">
                <li>
                    <a
                        className="privacy-link"
                        href="https://hb.bibank.com.ar/privacyPolicy"
                        target="_blank"
                        rel="noreferrer">
                        <I18n id="global.privacy.web" />
                    </a>
                </li>
                <li>
                    <Link to="/termsAndConditions">
                        <I18n id="global.termAndConditions" />
                    </Link>
                </li>
                <li>
                    <a className="help-link" href="https://ayuda.bibank.com.ar/" target="_blank" rel="noreferrer">
                        <I18n id="global.support" />
                    </a>
                </li>
                <li>
                    <Link to="/legalAdvice">
                        <I18n id="global.legalAdvice" />
                    </Link>
                </li>
                {Children.map(moreOptions, (option) => (
                    <li>{option}</li>
                ))}
            </ul>
        </footer>
    );
};

const mapStateToProps = (state) => ({
    messages: i18nSelectors.getMessages(state),
    currentStepRequest: environmentSelectors.getCurrentStepRequest(state),
});

FooterDesktop.propTypes = {
    moreOptions: arrayOf(shape({})),
    messages: shape({}),
    currentStepRequest: arrayOf(shape({})).isRequired,
};

FooterDesktop.defaultProps = {
    moreOptions: null,
    messages: null,
};

export default connect(mapStateToProps)(FooterDesktop);
